import React, { useEffect, useState } from "react";

import moneyBag from "../../assets/icons/money-bag-svgrepo-com.svg";
import wallet from "../../assets/icons/wallet-svgrepo-com.svg";
import { useGetBussinessBalance } from "../../lib/queries/queriesAndMutations";
import MoneyCard from "./MoneyCard";

const BusinessBalance = ({ type, id }) => {
  const { data } = useGetBussinessBalance({
    business_type: type,
    business_id: id,
  });

  return (
    <div className="grid grid-cols-2 md:grid-cols-1 h-fit w-full gap-4 min-w-fit md:max-w-fit  ">
      <MoneyCard img={moneyBag} title={"موجودی لحظه ای"} text={data?.total_balance} />
      <MoneyCard img={wallet} title={"موجودی قابل تسویه "} text={data?.available_balance} />
    </div>
  );
};

export default BusinessBalance;
